import Container from 'components/Container';
import { ROUTES } from 'constants/index';
import { useTranslation } from 'services/hooks';

import './style.css';

const Unauthorized = () => {
	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'unauthorized';

	return (
		<Container className="Unauthorized">
			<div className="main_title">{getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_title`)}</div>
			<div className="sub_title">
				{getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_sub_title`)}{' '}
				<a href={ROUTES.LOGIN}>{getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_sub_title_link`)}</a>
			</div>
		</Container>
	);
};

export default Unauthorized;
